export const GET_NOTES = 'GET_NOTES';
export const CLEAR_NOTES = 'CLEAR_NOTES';
export const ADD_NOTE = 'ADD_NOTE';
export const DELETE_NOTE = 'DELETE_NOTE';
export const NOTE_ERROR = 'NOTE_ERROR';
export const SET_CURRENT = 'SET_CURRENT';
export const CLEAR_CURRENT = 'CLEAR_CURRENT';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const FILTER_NOTES = 'FILTER_NOTES';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const ACCOUNT_UPDATED = 'ACCOUNT_UPDATED';
export const ACCOUNT_UPDATE_ERROR = 'ACCOUNT_UPDATE_ERROR';
export const ACCOUNT_DELETED = 'ACCOUNT_DELETED';
export const ACCOUNT_DELETE_ERROR = 'ACCOUNT_DELETE_ERROR';
export const SEND_LOGIN_LINK_SUCCESS = 'SEND_LOGIN_LINK_SUCCESS';
export const SEND_LOGIN_LINK_ERROR = 'SEND_LOGIN_LINK_ERROR';
